<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="p"><span><em class="i"><strong class="b">“You don’t know how relieved I feel at the prospect of having you back working with me. I’ve missed you...”</strong></em></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Eleri’s heart thumped as she looked down at their clasped hands, knowing she should pull away. “You were used to me, that’s all.”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>He reached up to turn her face to his, and their eyes met. “You mean I took you for granted.”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Eleri didn’t trouble to deny it, because his nearness was affecting her so badly she was afraid to trust her voice. With a smothered groan James pulled her into his arms and kissed her hungrily.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459262812_fm01.vue?0256f047